'use client';
import React, { useState } from 'react';
import { IoIosArrowForward, IoIosArrowBack } from 'react-icons/io';

export function JobsCarousel({ children }) {
  const [activeIndex, setActiveIndex] = useState(0);

  const updateIndex = (newIndex) => {
    if (newIndex < 0) {
      newIndex = children.length - 1;
    } else if (newIndex >= children.length) {
      newIndex = 0;
    }

    setActiveIndex(newIndex);
  };

  return (
    <div className="overflow-hidden">
      <div
        className="duration-1000 whitespace-nowrap"
        style={{
          transform: `translateX(-${activeIndex * 100}%)`,
        }}
      >
        {children}
      </div>
      <div className="flex justify-center items-center">
        <button
          className="p-2"
          onClick={() => {
            updateIndex(activeIndex - 1);
          }}
          title="Letztes Teammember Bild"
        >
          <IoIosArrowBack className="hover:fill-primaryColor m-2" />
        </button>
        {children.map((_, index) => {
          return (
            <button
              key={index}
              onClick={() => {
                updateIndex(index);
              }}
              className="p-[2vw] sm:px-3 py-5"
              title={`Teammember ${index}`}
            >
              <div
                className={`${
                  index === activeIndex
                    ? 'bg-primaryColor'
                    : 'bg-adsBackground dark:bg-lighterGrey'
                } w-4 h-[2px] rounded-xl m-1`}
              ></div>
            </button>
          );
        })}
        <button
          className="p-2"
          onClick={() => {
            updateIndex(activeIndex + 1);
          }}
          title="Nächstes Teammember Bild"
        >
          <IoIosArrowForward className="hover:fill-primaryColor m-2" />
        </button>
      </div>
    </div>
  );
}
